import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	paginationPrev: {
		id: 'servicedesk-reports-common.table.issue-table.pagination-prev',
		defaultMessage: 'Prev',
		description: 'Text for going to the previous page in the reports table',
	},
	paginationNext: {
		id: 'servicedesk-reports-common.table.issue-table.pagination-next',
		defaultMessage: 'Next',
		description: 'Text for going to the next page in the reports table',
	},
	noData: {
		id: 'servicedesk-reports-common.table.issue-table.no-data',
		defaultMessage: 'No data found for this period',
		description: 'Message shown when there is no information found for a particular period of time',
	},
});
